import styled, { css } from 'styled-components';

const ticketQuery = css`
  @media screen and (min-width: 1280px) and (max-width: 1450px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const sidebarQuery = css`
  @media screen and (max-width: 1100px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Bottom = styled.div`
  background-color: rgba(255, 255, 255, 0.5);
  padding: 9px 15px 0;
  border-top: 1px solid #b7b8b8;
`;

export const Statistics = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${props => props.ticket && ticketQuery}
  ${props => props.sidebar && sidebarQuery}
`;

export const StatisticsItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 9px;
`;
